module.exports = __webpack_public_path__ + "static/media/ea_expectations.3bb81012.png";